import React from "react";
import Sidebar from "../components/Sidebar";
import TopBar from "../components/TopBar";
import { LayoutContainer, AppInner, MainContent } from "./styles";

const BaseLayout = ({ children }) => {
  return (
    <LayoutContainer>
      <AppInner>
        <Sidebar />
        <MainContent>
          <TopBar />
          {children}
        </MainContent>
      </AppInner>
    </LayoutContainer>
  );
};

export default BaseLayout;
